import { configUrl } from "config";
import { useMemo, useState } from "react";
import { normalizeAttemptData } from "utils/normalizeAttemptData";
import PdfViewer from "../PDFBasedTestComponents/PdfViewer";
import AttemptQuestionPanel from "./AttemptQuestionPanel";

export default function PdfAttemptPlayer({ apiData, onFinish }) {
    const sections = useMemo(() => {
        return normalizeAttemptData(apiData);
    }, [apiData]);

    const [expandedPdf, setExpandedPdf] = useState(
        sections.map(() => true)
    );

    const togglePdf = (index) => {
        const copy = [...expandedPdf];
        copy[index] = !copy[index];
        setExpandedPdf(copy);
    };

    return (
        <div style={{ display: "flex", height: "85vh" }}>
            <div
                style={{
                    flex: 2,
                    borderRight: "1px solid #ddd",
                    overflowY: "auto",
                    padding: 10
                }}
            >
                {sections.map((section, index) => (
                    <div key={section.poolId} style={{ marginBottom: 20 }}>

                        {/* PDF Section Header */}
                        <div
                            onClick={() => togglePdf(index)}
                            style={{
                                cursor: "pointer",
                                fontWeight: 600,
                                padding: "10px",
                                background: "#f5f5f5",
                                borderRadius: 6,
                                marginBottom: 10
                            }}
                        >
                            Section {section.sequence} PDF
                            <span style={{ float: "right" }}>
                                {expandedPdf[index] ? "▲" : "▼"}
                            </span>
                        </div>

                        {/* PDF Viewer */}
                        {expandedPdf[index] && (
                            <div style={{ height: "400px" }}>
                                <PdfViewer
                                    fileUrl={`${configUrl.AssessmentServer}${section.pdf}`}
                                />
                            </div>
                        )}

                    </div>
                ))}
            </div>

            <div style={{ flex: 1, overflowY: "auto" }}>
                <AttemptQuestionPanel
                    sections={sections}
                    originalData={apiData}
                    onFinish={onFinish}
                />
            </div>
        </div>
    );
}